module.exports = __webpack_public_path__ + "img/img-search04.7dbd4011.jpg";